module.exports = __webpack_public_path__ + "img/business.a16c046d.png";